import {Flag} from 'platform/components';
import {useDateTimeFormatter} from 'platform/locale';

import {getTrimOrderability} from '../../utils/getTrimOrderability';
import {getOrderabilityFlagProps} from './getOrderabilityFlagProps';

export type OrderabilityChipProps = {
  trim: Parameters<typeof getTrimOrderability>[0];
  today?: Date;
};

export function OrderabilityChip(props: OrderabilityChipProps) {
  const formatDate = useDateTimeFormatter();
  const flagProps = getOrderabilityFlagProps(props.trim, props.today ?? new Date(), (date) =>
    formatDate('dateMedium', date)
  );

  return <Flag {...flagProps} />;
}
